import type { ExportJobDetail } from "@/types/api";
import { isUiMockMode } from "@/config/features";
import { mockExportDisplayTitle } from "@/fixtures/exportJobs";
import { formatCreateSource } from "@/domain/export/formatExportTitle";
import { exportStatusLabel } from "@/domain/export/exportStatusUi";
import { formatDateShort } from "@/utils/format/date";

export function exportDetailHeadline(job: ExportJobDetail): string {
  if (isUiMockMode()) {
    return mockExportDisplayTitle(job);
  }
  const date = formatDateShort(job.created_at);
  return `${date} · ${job.invoice_count} invoice${job.invoice_count === 1 ? "" : "s"}`;
}

export function exportDetailLead(job: ExportJobDetail): string {
  const source = formatCreateSource(job.source);
  const n = job.invoice_count;
  const suffix = n === 1 ? "invoice" : "invoices";
  const zip =
    job.status === "SUCCESS"
      ? "ZIP ready"
      : job.status === "RUNNING" || job.status === "PENDING"
        ? "ZIP in progress"
        : exportStatusLabel(job.status);
  return `${source} export · ${n} ${suffix} · ${zip}`;
}
